import { useState } from "react";
import { FaMapMarkerAlt, FaEnvelope, FaUser, FaPhoneAlt } from "react-icons/fa";

export default function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = encodeURIComponent(`New Enquiry from ${formData.name}`);
    const body = encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\n\nMessage:\n${formData.message}`
    );

    window.location.href = `mailto:legendimpex@yahoo.com?subject=${subject}&body=${body}`;
  };

  return (
    <div className="container mt-5 mb-5">

      {/* Quote Section */}
      <div className="quote-wrapper text-center mb-4">
        <span className="quote-line"></span>

        <p className="quote-text">
          True craftsmanship is not made to impress — it is made to last.
        </p>

        <span className="quote-line"></span>
      </div>

      <h2 className="text-center fw-bold mb-3 section-title">Get in Touch</h2>
      <p className="text-center mb-5 section-subtitle">
        Have questions or want to know more about our premium leather collection?
        We’d love to hear from you.
      </p>

      <div className="row g-4">

        {/* Contact Info */}
        <div className="col-md-5">
          <div className="p-4 bg-light rounded shadow-sm contact-info h-100">
            <h4 className="fw-bold mb-4">Contact Information</h4>

            <p>
              <FaUser className="me-2 text-warning" />
              <strong>CEO & Founder:</strong>&nbsp;Sachneet Singh
            </p>

            <p>
              <FaMapMarkerAlt className="me-2 text-danger" />
              <strong>Address:</strong>&nbsp;12/35 A Talimabad, Sangam Vihar,
              New Delhi-110080
            </p>

            <p>
              <FaEnvelope className="me-2 text-primary" />
              <strong>Email:</strong>&nbsp;legendimpex@yahoo.com
            </p>

            <p>
              <FaPhoneAlt className="me-2 text-success" />
              <strong>Phone:</strong>&nbsp;+91 9999055506
            </p>

            <p className="mt-3 fst-italic text-muted">
              We respond within 24 hours.
            </p>
          </div>
        </div>

        {/* Contact Form */}
        <div className="col-md-7">
          <form
            onSubmit={handleSubmit}
            className="p-4 bg-white rounded shadow-sm contact-form"
          >
            <div className="mb-3">
              <label className="form-label fw-bold">Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                placeholder="Your Name"
                required
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Email</label>
              <input
                type="email"
                name="email"
                className="form-control"
                placeholder="you@example.com"
                required
                onChange={handleChange}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-bold">Message</label>
              <textarea
                name="message"
                className="form-control"
                rows="5"
                placeholder="Write your message..."
                required
                onChange={handleChange}
              ></textarea>
            </div>

            <button type="submit" className="btn btn-gradient w-100 fw-bold">
              Send Message
            </button>
          </form>
        </div>
      </div>

      {/* CSS */}
      <style>{`
        /* Quote Styling */
        .quote-wrapper {
          padding: 25px 15px;
        }

        .quote-text {
          font-size: 1.45rem;
          font-style: italic;
          font-weight: 500;
          color: #2b2b2b;
          max-width: 820px;
          margin: 12px auto;
          line-height: 1.6;
          letter-spacing: 0.5px;
          position: relative;
        }

        .quote-text::before,
        .quote-text::after {
          font-size: 3rem;
          color: #ff6a00;
          position: absolute;
          opacity: 0.25;
        }

        .quote-text::before {
          content: "“";
          left: -25px;
          top: -10px;
        }

        .quote-text::after {
          content: "”";
          right: -25px;
          bottom: -20px;
        }

        .quote-line {
          display: block;
          width: 120px;
          height: 3px;
          margin: 0 auto;
          background: linear-gradient(to right, transparent, #ff6a00, transparent);
          border-radius: 3px;
        }

        /* Titles */
        .section-title {
          font-size: 2.2rem;
          position: relative;
          display: inline-block;
        }

        .section-title::after {
          content: "";
          display: block;
          width: 70px;
          height: 4px;
          background: linear-gradient(to right, #ffdd00, #ff6a00);
          margin: 10px auto 0;
          border-radius: 2px;
        }

        .section-subtitle {
          color: #555;
          font-size: 1.1rem;
        }

        /* Contact Info */
        .contact-info p {
          font-size: 1rem;
          margin-bottom: 0.8rem;
          display: flex;
          align-items: center;
        }

        .contact-info:hover {
          transform: translateY(-5px);
          transition: all 0.3s ease;
        }

        /* Form */
        .contact-form input,
        .contact-form textarea {
          border-radius: 6px;
          transition: all 0.3s ease;
        }

        .contact-form input:focus,
        .contact-form textarea:focus {
          border-color: #ff6a00;
          box-shadow: 0 0 8px rgba(255, 106, 0, 0.3);
          outline: none;
        }

        .btn-gradient {
          background: linear-gradient(to right, #ffdd00, #ff6a00);
          color: #fff;
          border: none;
          padding: 10px 0;
          font-size: 1.1rem;
          transition: all 0.3s ease;
        }

        .btn-gradient:hover {
          transform: scale(1.05);
          box-shadow: 0 6px 20px rgba(255,106,0,0.5);
        }
      `}</style>
    </div>
  );
}
